// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, bool, func, oneOfType, object, string } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Heading } from 'components/SearchAndSelect/Sets/PathDb/components'
import reportingIcon from 'images/sheet.png'
import Form from './Form'
import exportPathData from './exportPathData'

class PathReportExport extends React.Component {
  static propTypes = {
    allRowsHighlighted: bool,
    asc: string,
    closeModal: func.isRequired,
    dataSource: string.isRequired,
    exportPathData: func.isRequired,
    highlightedRows: oneOfType([
      array.isRequired,
      object.isRequired,
    ]),
    idRoot: string.isRequired,
    sourceForm: string,
    supportUnderline: bool,
    datasheetVersion: string,
  }

  onSubmit = async formData => {
    const {
      allRowsHighlighted,
      asc,
      closeModal,
      dataSource,
      exportPathData,
      highlightedRows,
      sourceForm,
      datasheetVersion,
    } = this.props

    await exportPathData({
      allRowsHighlighted,
      asc,
      dataSource,
      highlightedRows,
      formData,
      sourceForm,
      datasheetVersion,
    })
    closeModal()
  }

  render () {
    const {
      closeModal,
      idRoot,
      supportUnderline,
    } = this.props

    return (
      <div className={'path-db-export-paths'}>
        <Heading
          heading={'Path Database Export'}
          iconPath={reportingIcon}
          idRoot={idRoot} />
        <Form
          closeModal={closeModal}
          idRoot={idRoot}
          onSubmit={this.onSubmit}
          supportUnderline={supportUnderline} />
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    exportPathData,
  }, dispatch)
)

const r = connect(
  null,
  mapDispatchToProps
)(PathReportExport)

export default r
